import { groupRequest } from '../../request/index';

export default {
  namespaced: true,

  state: {
    // 是否显示首次引导提示
    firstBootTipVisible: false,
    // 是否显示数据导出中心
    dataExportCenterVisible: false,
    allExportedData: [],
    // 是否需要轮询
    isNeedPoll: false,
  },

  actions: {
    /**
     * 获取数据导出中心任务列表
     * http://yapi.igeeker.org/project/321/interface/api/4088
     * @param {*} ctx
     * @param {number} pageNumber 当前页数，第几页
     * @param {number} pageSize 分页大小
     * @returns
     */
    getExportList(ctx, { pageNumber = 1, pageSize = 10 } = {}) {
      return groupRequest.get('/group/export/list', {
        params: {
          pageNumber,
          pageSize
        },
      });
    },
    /**
     * 重新生成
     * http://yapi.igeeker.org/project/321/interface/api/4091
     * @param {*} ctx
     * @param {number} id 导入日志ID
     * @returns
     */
    reBuild(ctx, { id }) {
      return groupRequest.post('/group/export/redo', {
        data: {
          id
        },
        requestType: 'json'
      });
    },
    /**
     * 数据导出中心状态 得到的是一条任务纪录
     * http://yapi.igeeker.org/project/321/interface/api/4094
     */
    getExportStatus() {
      return groupRequest.get('/group/export/status/get');
    },
    /**
     * 获取指定时间后，已完成的任务
     * http://yapi.igeeker.org/project/321/interface/api/4097
     * @param {*} ctx
     * @param {number} startTime 开始时间
     * @returns
     */
    getSuccessData(ctx, { startTime = '' } = {}) {
      return groupRequest.get('/group/export/success-data/get', {
        params: {
          startTime
        }
      });
    }
  },

  mutations: {
    setFirstBootTipVisible(state, firstBootTipVisible) {
      state.firstBootTipVisible = firstBootTipVisible;
    },
    setDataExportCenterVisible(state, dataExportCenterVisible) {
      state.dataExportCenterVisible = dataExportCenterVisible;
    },
    setAllExportedData(state, allExportedData) {
      state.allExportedData = allExportedData;
    },
    setIsNeedPoll(state, isNeedPoll) {
      state.isNeedPoll = isNeedPoll;
    }
  },
};
